import axios from 'axios';
import mediaTypesApi from '@/api/artist/media-types';
import loadingMutation from '@motionelements/core/src/store/mutations-mixins/loadingMutation.js';

function refreshCancelToken(state, tokenName) {
  // cancel previous request
  if (_.has(state.cancelTokens, tokenName)) {
    const info = {
      type: 'cancelToken',
      name: `${tokenName}`,
    };
    state.cancelTokens[tokenName].cancel(info);
  }

  // create cancel token
  state.cancelTokens[tokenName] = axios.CancelToken.source();

  return state.cancelTokens[tokenName];
}

const state = {
  list: [],
  loading: false,
  error: false,
  //
  cancelTokens: {},
};

const mutations = {
  setAiModelsList(state, models) {
    state.list = models;
  },
};

const actions = {
  LIST_AI_MODELS({ commit }, generator) {
    commit('setError', false);
    const cancelToken = refreshCancelToken(state, 'listAiModels');
    const axiosConfig = { cancelToken: cancelToken.token };
    commit('setLoading', true);
    return mediaTypesApi.getAiModels(generator, axiosConfig)
      .then(({ data: { data: aiModels } }) => {
        console.log(aiModels);
        commit('setAiModelsList', aiModels);
        commit('setLoading', false);
      })
      .catch(err => {
        console.error(err);
        if (!axios.isCancel(err)) {
          commit('setError', true);
          commit('setLoading', false);
        }
      });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations: { ...mutations, ...loadingMutation },
};
